import styles from "./index.module.css";

const EmptyCheck = () => <div className={styles.root}></div>;

export default EmptyCheck;
